module.exports = "/src/views/player/help/images/ar.jpg";